import { Col, Select } from 'antd';
import { useDefaultEmptyFieldError } from '@/hooks';
import FloatingFormItem from '../FloatingFormItem';
import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';

interface Props {
  isInternal?: boolean;
}

const CancellationCodeSelect = ({ isInternal = false }: Props) => {
  const { cancellationCode } = useInvoiceFormContext();

  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  const options = cancellationCode?.map((code) => ({
    label: `${code.code} - ${code.description}`,
    value: code.code,
  }));

  return (
    <Col span={24}>
      <FloatingFormItem
        name="codeCancellation"
        label="Motivo"
        rules={isInternal ? [defaultEmptyFieldError] : undefined}
      >
        <Select style={{ width: '100' }} options={options} />
      </FloatingFormItem>
    </Col>
  );
};

export default CancellationCodeSelect;
